export const defineNavigation = (icon, text, link, isVisible = true, isNew = false, isDisabled = false, path = null, subPath = []) => {
  return {
    icon: icon,
    text: text,
    link: link,
    visible: isVisible,
    is_new: isNew,
    disable: isDisabled,
    urlMap: path ? path : link ? link.replace('/', '') : '',
    subPath: subPath
  }
}